<div *ngIf="initialized" class="w3-container w3-margin-top" [class]="router.back ? 'w3-animate-left' : 'w3-animate-right'">
  <omnipas-pageheader></omnipas-pageheader>
  <div *ngIf="!message.error && !showLogout && !change" #deliveryAddress id="deliveryAddress" class="w3-margin">
    <p>{{ 'pagetext.deliveryaddress' | translate: router.transparams }} </p>
    <p>{{ 'deliveryaddress.line1' | translate: router.transparams }}</p>
    <p>
      <b>
        <span>{{ existingAddressLine1 }}</span>
        <br/>
        <span>{{ existingAddressLine2 }}</span>
      </b>
    </p>
    <p>{{ 'deliveryaddress.line2' | translate: router.transparams }}</p>
    <p>{{ 'deliveryaddress.line3' | translate: router.transparams }}</p>
    <p>{{ 'deliveryaddress.line4' | translate: router.transparams }}</p>
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile pageButton w3-round"
      name        = "back"
      value       = "{{ 'buttons.agree' | translate: router.transparams }}"
      title       = "{{ 'buttons.agree' | translate: router.transparams }}"
      (click)     = "agree()"
    >
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile pageButton w3-round"
      name        = "logout"
      value       = "{{ 'buttons.changeaddress' | translate: router.transparams }}"
      title       = "{{ 'buttons.changeaddress' | translate: router.transparams }}"
      (click)     = "toggleChange()"
    >
  </div>
  <div *ngIf="!message.error && !showLogout && change" #deliveryAddress id="deliveryAddress" class="w3-margin">
    <label for="postalcode">{{ 'labels.postalcode' | translate: router.transparams }}</label>
    <input
      id              = "postalcode"
      name            = "postalcode"
      class           = "w3-input w3-border w3-input-theme w3-round"
      type            = "text"
      placeholder     = "9999 AA"
      pattern         = "[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}"
      autocomplete    = "off"
      [(ngModel)]     = "postalcode"
      (change)        = "formatZipCode(); searchAddress();"
      required        = "required"
      tabindex        = "1"
    >
    <label for="housenumber">{{ 'labels.housenumber' | translate: router.transparams }}</label>
    <input
      id              = "housenumber"
      name            = "housenumber"
      class           = "w3-input w3-border w3-input-theme w3-round"
      type            = "text"
      placeholder     = "99999"
      pattern         = "[1-9][0-9]{4}"
      autocomplete    = "off"
      [(ngModel)]     = "housenumber"
      (keyup.enter)   = "searchAddress()"
      (blur)          = "searchAddress()"
      (change)        = "searchAddress()"
      required        = "required"
      tabindex        = "2"
    >
    <label for="housenumbersuffix">{{ 'labels.housenumbersuffix' | translate: router.transparams }}</label>
    <input
      id            = "housenumbersuffix"
      name          = "housenumbersuffix"
      class         = "w3-input w3-border w3-input-theme w3-round"
      type          = "text"
      placeholder   = ""
      pattern       = ""
      autocomplete  = "off"
      [(ngModel)]   = "housenumbersuffix"
      tabindex      = "3"
    >

    <p *ngIf="!searching && !addressfound">{{ 'deliveryaddress.line6' | translate: router.transparams }}</p>
    <p *ngIf="searching">{{ 'deliveryaddress.searching' | translate: router.transparams }}</p>
    <p *ngIf="addressfound">{{ 'deliveryaddress.line7' | translate: router.transparams }}</p>
    <p *ngIf="addressfound">
      <b>{{ street }} {{ housenumber }} {{ housenumbersuffix }}<br/>{{ postalcode }}&nbsp; &nbsp;{{ city }}</b>
    </p>
    <p *ngIf="addressfound">{{ 'deliveryaddress.line8' | translate: router.transparams }}</p>
    <input
      *ngIf       = "addressfound"
      type        = "submit"
      class       = "w3-button w3-border w3-button-theme w3-mobile w3-margin-right pageButton w3-round"
      name        = "submit"
      value       = "{{ 'buttons.save' | translate: router.transparams }}"
      title       = "{{ 'buttons.save' | translate: router.transparams }}"
      (click)     = "submit()"
      [disabled]  = "enableSubmit()"
    >
  </div>
  <div *ngIf="message.error">
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile pageButton w3-round"
      name        = "back"
      value       = "{{ 'buttons.back' | translate: router.transparams }}"
      title       = "{{ 'buttons.back' | translate: router.transparams }}"
      (click)     = "back()"
    >
    <input
      type        = "button"
      class       = "w3-button w3-border w3-button-theme w3-mobile pageButton w3-round"
      name        = "logout"
      value       = "{{ 'buttons.logout' | translate: router.transparams }}"
      title       = "{{ 'buttons.logout' | translate: router.transparams }}"
      (click)     = "cancel()"
    >
  </div>
  <div *ngIf="showLogout && change" class="w3-margin">
    <p>{{ 'deliveryaddress.line9' | translate: router.transparams }}</p>
    <p>
      <b>
        <span>{{ this.newAddressLine1 }}</span>
        <br/>
        <span>{{ this.newAddressLine2 }}</span>
      </b>
    </p>
    <input type="button" class="w3-button w3-border w3-button-theme w3-mobile pageButton w3-round" name="logout"
      value="{{ 'buttons.logout' | translate: router.transparams }}"
      title="{{ 'buttons.logout' | translate: router.transparams }}" (click)="logout()">
  </div>
  <div *ngIf="showLogout && !change" class="w3-margin">
    <p>{{ 'activate.logout' | translate: router.transparams }}</p>
    <input type="button" class="w3-button w3-border w3-button-theme w3-mobile pageButton w3-round" name="logout"
      value="{{ 'buttons.logout' | translate: router.transparams }}"
      title="{{ 'buttons.logout' | translate: router.transparams }}" (click)="logout()">
  </div>
</div>
